import { PlusOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import _ from 'lodash';
import React, { useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import displayLoading from '../../../redux/actions/loading';
import { useIntersectionObserver, useMergeState } from '../../../utils/hooks';
import NormalTable from '../../components/tables/normalTable';
import { getCardLicenseStatusColumns, getCardLicenseStatusSearchBy, handleFetchCardLicense } from './helper';

import './style.scss';

const CardLicenseAndStatus = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useMergeState({
    isLoadingMore: false,
    cardLicenses: [],
    cursor: undefined,
    lastElement: undefined,
  });

  const searchKey = useRef();
  const columns = useMemo(() => getCardLicenseStatusColumns());
  const searchBy = useMemo(() => getCardLicenseStatusSearchBy());

  const onRowClick = (row) => {
    history.push(`/card-information/${row.eID}`);
  };

  const onSearchOrFilter = async (keySearch, filter) => {
    dispatch(displayLoading(true));
    searchKey.current = keySearch;
    const listEsimsFilterInput = { [searchKey.current.key]: searchKey.current.value };
    const cardLicenses = await handleFetchCardLicense(listEsimsFilterInput, 20);
    setState({
      cardLicenses: cardLicenses || [],
      cursor: cardLicenses.length < 20 ? undefined : cardLicenses[cardLicenses.length - 1]?.eID || undefined,
    });
    dispatch(displayLoading(false));
  };

  const handleLoadMore = async () => {
    if (state.isLoadingMore || !state.cursor) {
      return;
    }
    const listEsimsFilterInput = { cursor: state.cursor };
    if (searchKey.current) {
      Object.assign(listEsimsFilterInput, { [searchKey.current.key]: searchKey.current.value });
    }
    setState({ isLoadingMore: true });
    const cardLicenses = await handleFetchCardLicense(listEsimsFilterInput, 20);
    if (!_.isEmpty(cardLicenses)) {
      setState({
        cardLicenses: [...state.cardLicenses, ...cardLicenses],
        cursor: cardLicenses.length < 20 ? undefined : cardLicenses[cardLicenses.length - 1]?.eID || undefined,
      });
    }
    setState({ isLoadingMore: false });
  };

  const onCreate = () => {
    history.push('/add-new-card', { from: '/card-license' });
  };

  useEffect(() => {
    const fetchInitData = async () => {
      dispatch(displayLoading(true));
      const cardLicenses = await handleFetchCardLicense({}, 20);
      setState({ cardLicenses, cursor: cardLicenses.length < 20 ? undefined : cardLicenses[cardLicenses.length - 1]?.eID || undefined });
      dispatch(displayLoading(false));
    };
    fetchInitData();
  }, []);

  useEffect(() => {
    if (!_.isEmpty(state.cardLicenses)) {
      const rowElements = document.querySelectorAll('.ant-table-row-level-0');
      setState({ lastElement: rowElements[rowElements.length - 1] });
    }
  }, [state.cardLicenses, state.isLoadingMore]);

  useIntersectionObserver(state.lastElement, handleLoadMore, () => {}, [state.cardLicenses, state.cursor]);

  return (
    <div className="card-license-status">
      <NormalTable
        className="card-license-status-table"
        columns={columns}
        dataSource={state.cardLicenses}
        isCreate
        isSearch
        searchBy={searchBy}
        createType="Add new card"
        onCreate={onCreate}
        fetchData={onSearchOrFilter}
        icon={<PlusOutlined />}
        onRowClick={onRowClick}
      />
      <div className="loadmore">
        {state.isLoadingMore && <Spin />}
      </div>
    </div>
  );
};

export default CardLicenseAndStatus;
